<template>
  <div class="box">
    <div class="per-box">
      <ul class="info-list">
        <li class="active">
          <label>手机</label>
          <p>
            <span v-text="perData.phone"></span>
            <i class="iconfont" @click="showPhone"></i>
          </p>
        </li>
        <li>
          <label>邮箱</label>
          <p>
            <span v-text="perData.email"></span>
            <i class="iconfont" @click="showEmail"></i>
          </p>
        </li>
        <li>
          <label>密码</label>
          <p class="change-pass" @click="changePass">修改密码</p>
        </li>
        <li>
          <label>生日</label>
          <p>
            <span v-text="perData.shengRi"></span>
            <i class="iconfont" @click="setBorth"></i>
          </p>
        </li>
        <li class="active">
          <label>微博</label>
          <p>
            <span v-text="perData.weiBo"></span>
            <i class="iconfont" @click="showWeibo"></i>
          </p>
        </li>
      </ul>
    </div>
    <component v-show="panelModal" v-bind:is="name" @addData="refresh"></component>
  </div>
</template>
<script>
import $ from "jquery";
import bindPhone from "../login/bindPhone";
import bindEmail from "../login/bindEmail";
import changePassword from "../login/changePassword";
import bindWeibo from "../login/bindWeibo";
export default {
  //   name: "App",
  data() {
    return {
      panelModal: false,
      code: false,
      name: "",
      list: [],
      perData: {
        email: "",
        shengRi: ""
      }
    };
  },
  components: {
    bindPhone,
    bindEmail,
    changePassword,
    bindWeibo
  },
  mounted() {
    this.getData();
  },
  methods: {
    refresh: function() {
      //刷新父组件方法
      this.getData();
    },
    showPhone() {
      this.name = "bindPhone";
      this.panelModal = true;
    },
    showEmail() {
      this.name = "bindEmail";
      this.panelModal = true;
    },
    changePass() {
      this.name = "changePassword";
      this.panelModal = true;
    },
    showWeibo() {
      this.name = "bindWeibo";
      this.panelModal = true;
    },
    setBorth() {
      //设置生日
      this.$parent.n = 0;
      this.$router.push({ path: "/perData"});
    },
    getData() {
      //获取用户信息
      this.$http
        .get("/api/user/013-getUserInfoById", {
          params: {
            id: this.$store.state.userInfo.id
          }
        })
        .then(res => {
          if (res.status == 200 && res.data.code == 0) {
            this.perData = res.data.rows[0];
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>
<style scoped>
.per-info .per-box {
  height: 312px;
}
.per-info .info-list li p.change-pass {
  cursor: pointer;
}
.per-info .info-list li span {
  margin-right: 10px;
}
</style>